import { ReactNode, useReducer } from 'react';
import PoolContext from './poolContext';
import poolReducer from './poolReducer';
import { PoolStateType } from './poolTypes';

type PoolStateProps = {
    children: ReactNode;
};

const initialState: PoolStateType = {
    selectedLiquidityPool: undefined,
    renderDepositInterface: false,
    renderWithdrawInterface: false,
    renderExposure: false,
    selectedLockUp: {
        duration: undefined,
        feeMultiplier: undefined,
        lockUpId: undefined,
    },
    depositAmount: '',
    withdrawAmount: '',
};

const PoolState: React.FC<PoolStateProps> = ({ children }) => {
    const [state, dispatch] = useReducer(poolReducer, initialState);

    return (
        <PoolContext.Provider value={{ ...state, dispatch }}>
            {children}
        </PoolContext.Provider>
    );
};

export default PoolState;
